import { forwardRef } from 'react';

const variants = {
  primary: 'bg-gradient-to-r from-primary to-fuchsia-600 text-white hover:brightness-110 focus-visible:ring-primary',
  secondary: 'bg-zinc-100 text-zinc-900 hover:bg-zinc-200 dark:bg-zinc-800 dark:text-white dark:hover:bg-zinc-700 focus-visible:ring-primary',
  danger: 'bg-red-600 text-white hover:bg-red-700 focus-visible:ring-red-500',
};

export const ActionButton = forwardRef(function ActionButton({ variant = 'primary', type = 'button', className = '', ...props }, ref) {
  return <button {...props} ref={ref} type={type} className={`flex min-h-12 w-full items-center justify-center gap-2 rounded-xl px-4 py-3 text-base font-semibold leading-6 transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${variants[variant] || variants.primary} ${className}`} />;
});

export default function FormActions({ children, className = '' }) {
  return <div className={`flex w-full flex-col gap-3 ${className}`} data-form-actions>{children}</div>;
}
